import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aa52350"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "card-body pt-0 compact-table" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentLogsAdvancedSearch = _resolveComponent("PaymentLogsAdvancedSearch")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'payments'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PaymentLogsAdvancedSearch, {
                onTypeSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge.id), 1)
            ]),
            "cell-status": _withCtx(({ row: charge }) => [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.statusClass(charge.status))
              }, _toDisplayString(charge.status ?? ' - '), 3)
            ]),
            "cell-amount": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge.amount ?? ' - '), 1)
            ]),
            "cell-name": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge.name ?? ' - '), 1)
            ]),
            "cell-paymentMethod": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge.paymentMethod ?? ' - '), 1)
            ]),
            "cell-platform": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge.platform ?? ' - '), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(charge.createdAt)), 1)
            ]),
            "cell-chargeId": _withCtx(({ row: charge }) => [
              _createElementVNode("span", {
                class: "truncatable-cell",
                title: charge?.chargeId
              }, _toDisplayString(charge.chargeId ?? ' - '), 9, _hoisted_6)
            ]),
            "cell-customerId": _withCtx(({ row: charge }) => [
              _createElementVNode("span", {
                class: "truncatable-cell",
                title: charge?.customerId
              }, _toDisplayString(charge.customerId ?? ' - '), 9, _hoisted_7)
            ]),
            "cell-packageName": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge?.packageName ?? ' - '), 1)
            ]),
            "cell-service": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge?.service ?? ' - '), 1)
            ]),
            "cell-phone": _withCtx(({ row: charge }) => [
              _createTextVNode(_toDisplayString(charge?.phone ?? ' - '), 1)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}